import React, { useState } from 'react';
import { VStack } from '@chakra-ui/react';
import StatusDropdown from './InfoComponents/StatusDropdown'
import DueDate from './InfoComponents/DueDate';
import Reporter from './InfoComponents/Reporter';
import Assignee from './InfoComponents/Assignee';
import Members from './InfoComponents/Members';
import Timestamps from './InfoComponents/Timestamps';

const InfoTab = ({ task, columns, setColumns, moveCardAPI }) => {
  const [currentTask, setCurrentTask] = useState(task);

  const handleTaskUpdate = (updatedTask) => {
    setCurrentTask(updatedTask);
    // Optionally update parent state or trigger other side effects
  };

  return (
    <VStack align="stretch" spacing={6}>
      <StatusDropdown 
        task={currentTask} 
        columns={columns} 
        setColumns={setColumns} 
        moveCardAPI={moveCardAPI} 
      />
      
      <DueDate 
        task={currentTask} 
        onUpdate={handleTaskUpdate} 
      />
      
      <Reporter task={currentTask} />
      
      <Assignee 
        task={currentTask} 
        onUpdate={handleTaskUpdate} 
      />
      
      <Members task={currentTask} />
      
      <Timestamps task={currentTask} />
    </VStack>
  );
};

export default InfoTab;